import axios from 'axios';
import router from '@/router/index';
import { toast } from 'vue3-toastify';

export const onInstanceCreate = () => {
    const instance = axios.create({
        baseURL: import.meta.env.VITE_KASANOWA_API_HOST,
        withCredentials: true,
        withXSRFToken: true,
        headers: {
            common: {
                Authorization: '',
                Accept: 'application/json'
            },
        },
    });

    instance.interceptors.response.use((response: any) => {
        return response;
    }, (error: any) => {
        const errorResponse = {
            code: 0,
            message: '',
            data: error.response.data || [],
        };

        const errorCode = error.response.status;

        errorResponse.code = errorCode;

        switch (errorCode) {
	        case 401:
                // errorResponse.message = 'Unauthenticated.';
	            // router.push('/');
                // toast.error('Sesja wygasła');
                // break;
            case 422:
	            // toast.error('Error');
                break;
            default:
                break;
        }

        return Promise.reject(errorResponse);
    })

    return instance;
}

export default onInstanceCreate;
